import api from './api'

export default {
  getPerfil (request = {}) {
    return api.get('/validar', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  },

  logoutPerfil (request = {}) {
    return api.get('/logout', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  }

}
